var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewCardOptionDigital(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 312,
    viewBox: "0 0 212 312",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 312,
    rx: 20,
    fill: "#3AF2AE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8507 43.7432H27.479L30.3424 33.3283L33.2058 43.7432H35.8342L40.6848 27.2569H37.3727L34.4879 37.6017L31.6673 27.2569H29.0389L26.2183 37.5783L23.3335 27.2569H20L24.8507 43.7432Z",
    fill: "#07132B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9082 30.5199V43.7429H45.2631V30.5199H41.9082Z",
    fill: "#07132B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2739 27.2569H46.5488V30.4561H51.2713V43.7432H54.6262V30.4561H59.3486V27.2569H54.6243V30.4556H51.2739V27.2569Z",
    fill: "#07132B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6357 43.7432H63.9906V36.8544H69.9738V43.7432H73.3501V27.2569H69.9738V33.6786H63.9906V27.2569H60.6357V43.7432Z",
    fill: "#07132B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6406 40.5215H78.9953V43.7432H85.6839V40.5206H78.9955V27.2569H75.6406V40.5215Z",
    fill: "#07132B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.8691 43.7432H87.0352V43.7431H90.3874V40.571H87.0352V27.2569H97.7622V30.4094H90.39V33.7954H97.1212V36.8544H90.39V40.5673H97.8691V43.7432Z",
    fill: "#07132B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.729 44C107.362 44 109.52 42.1085 109.52 38.956C109.52 32.9547 102.447 34.3791 102.447 31.5069C102.447 30.5962 103.152 30.1058 104.349 30.1058C105.503 30.1058 106.4 30.5962 107.298 31.6236L109.477 29.2651C108.345 27.8874 106.529 27 104.413 27C101.293 27 99.1136 28.8214 99.1136 31.8571C99.1136 37.6484 106.187 36.1772 106.187 39.283C106.187 40.2637 105.353 40.8709 103.943 40.8709C102.362 40.8709 101.229 40.1937 100.267 38.956L98.0879 41.3146C99.5623 43.136 101.25 44 103.729 44Z",
    fill: "#07132B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.21 44C118.842 44 121.001 42.1085 121.001 38.956C121.001 32.9547 113.928 34.3791 113.928 31.5069C113.928 30.5962 114.633 30.1058 115.829 30.1058C116.983 30.1058 117.881 30.5962 118.778 31.6236L120.958 29.2651C119.825 27.8874 118.009 27 115.893 27C112.774 27 110.594 28.8214 110.594 31.8571C110.594 37.6484 117.667 36.1772 117.667 39.283C117.667 40.2637 116.834 40.8709 115.423 40.8709C113.842 40.8709 112.71 40.1937 111.748 38.956L109.568 41.3146C111.043 43.136 112.731 44 115.21 44Z",
    fill: "#07132B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M174.661 268.803H186.269V289.407H174.661V268.803Z",
    fill: "#FF5F00"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M175.399 279.105C175.399 274.919 177.388 271.206 180.447 268.803C178.199 267.056 175.362 266 172.266 266C164.933 266 159 271.861 159 279.105C159 286.35 164.933 292.211 172.266 292.211C175.362 292.211 178.199 291.155 180.447 289.407C177.388 287.041 175.399 283.292 175.399 279.105Z",
    fill: "#EB001B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M201.931 279.105C201.931 286.349 195.998 292.211 188.665 292.211C185.57 292.211 182.732 291.155 180.484 289.407C183.58 287.005 185.533 283.292 185.533 279.105C185.533 274.919 183.543 271.206 180.484 268.803C182.732 267.056 185.57 266 188.665 266C195.998 266 201.931 271.897 201.931 279.105Z",
    fill: "#F79E1B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 24.7998 80.5465)",
    fill: "#66C0DD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 20.1758 80.5465)",
    fill: "#66C0DD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.4121 80.7033)",
    fill: "#66C0DD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.4121 76)",
    fill: "#66C0DD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 51.9863 80.5465)",
    fill: "#66C0DD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 47.3623 80.5465)",
    fill: "#66C0DD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.5986 80.7033)",
    fill: "#66C0DD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.5986 76)",
    fill: "#66C0DD"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 79.1719 80.5465)",
    fill: "#66C0DD"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 74.5479 80.5465)",
    fill: "#66C0DD"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.7842 80.7033)",
    fill: "#66C0DD"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.7842 76)",
    fill: "#66C0DD"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 106.358 80.5465)",
    fill: "#66C0DD"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 101.734 80.5465)",
    fill: "#66C0DD"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.971 80.7033)",
    fill: "#66C0DD"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.971 76)",
    fill: "#66C0DD"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 133.545 80.5465)",
    fill: "#66C0DD"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 128.921 80.5465)",
    fill: "#66C0DD"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 132.157 80.7033)",
    fill: "#66C0DD"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 132.157 76)",
    fill: "#66C0DD"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 160.73 80.5465)",
    fill: "#66C0DD"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 156.106 80.5465)",
    fill: "#66C0DD"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.343 80.7033)",
    fill: "#66C0DD"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.343 76)",
    fill: "#66C0DD"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 187.917 80.5465)",
    fill: "#66C0DD"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 183.293 80.5465)",
    fill: "#66C0DD"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.529 80.7033)",
    fill: "#66C0DD"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.529 76)",
    fill: "#66C0DD"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 24.7998 106.385)",
    fill: "#66C0DD"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 20.1758 106.385)",
    fill: "#66C0DD"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.4121 106.542)",
    fill: "#66C0DD"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.4121 101.839)",
    fill: "#66C0DD"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 51.9863 106.385)",
    fill: "#66C0DD"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 47.3623 106.385)",
    fill: "#66C0DD"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.5986 106.542)",
    fill: "#66C0DD"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.5986 101.839)",
    fill: "#66C0DD"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 79.1719 106.385)",
    fill: "#66C0DD"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 74.5479 106.385)",
    fill: "#66C0DD"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.7842 106.542)",
    fill: "#66C0DD"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.7842 101.839)",
    fill: "#66C0DD"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 106.358 106.385)",
    fill: "#66C0DD"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 101.734 106.385)",
    fill: "#66C0DD"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.971 106.542)",
    fill: "#66C0DD"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.971 101.839)",
    fill: "#66C0DD"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 133.545 106.385)",
    fill: "#66C0DD"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 128.921 106.385)",
    fill: "#66C0DD"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 132.157 106.542)",
    fill: "#66C0DD"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 132.157 101.839)",
    fill: "#66C0DD"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 160.73 106.385)",
    fill: "#66C0DD"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 156.106 106.385)",
    fill: "#66C0DD"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.343 106.542)",
    fill: "#66C0DD"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.343 101.839)",
    fill: "#66C0DD"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 187.917 106.385)",
    fill: "#66C0DD"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 183.293 106.385)",
    fill: "#66C0DD"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.529 106.542)",
    fill: "#66C0DD"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.529 101.839)",
    fill: "#66C0DD"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 24.7998 132.224)",
    fill: "#66C0DD"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 20.1758 132.224)",
    fill: "#66C0DD"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.4121 132.381)",
    fill: "#66C0DD"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.4121 127.678)",
    fill: "#66C0DD"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 51.9863 132.224)",
    fill: "#66C0DD"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 47.3623 132.224)",
    fill: "#66C0DD"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.5986 132.381)",
    fill: "#66C0DD"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.5986 127.678)",
    fill: "#66C0DD"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 79.1719 132.224)",
    fill: "#66C0DD"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 74.5479 132.224)",
    fill: "#66C0DD"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.7842 132.381)",
    fill: "#66C0DD"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.7842 127.678)",
    fill: "#66C0DD"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 106.358 132.224)",
    fill: "#66C0DD"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 101.734 132.224)",
    fill: "#66C0DD"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.971 132.381)",
    fill: "#66C0DD"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.971 127.678)",
    fill: "#66C0DD"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 133.545 132.224)",
    fill: "#66C0DD"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 128.921 132.224)",
    fill: "#66C0DD"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 132.157 132.381)",
    fill: "#66C0DD"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 132.157 127.678)",
    fill: "#66C0DD"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 160.73 132.224)",
    fill: "#66C0DD"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 156.106 132.224)",
    fill: "#66C0DD"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.343 132.381)",
    fill: "#66C0DD"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.343 127.678)",
    fill: "#66C0DD"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 187.917 132.224)",
    fill: "#66C0DD"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 183.293 132.224)",
    fill: "#66C0DD"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.529 132.381)",
    fill: "#66C0DD"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.529 127.678)",
    fill: "#66C0DD"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 24.7998 158.063)",
    fill: "#66C0DD"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 20.1758 158.063)",
    fill: "#66C0DD"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.4121 158.22)",
    fill: "#66C0DD"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.4121 153.517)",
    fill: "#66C0DD"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 51.9863 158.063)",
    fill: "#66C0DD"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 47.3623 158.063)",
    fill: "#66C0DD"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.5986 158.22)",
    fill: "#66C0DD"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.5986 153.517)",
    fill: "#66C0DD"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 79.1719 158.063)",
    fill: "#66C0DD"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 74.5479 158.063)",
    fill: "#66C0DD"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.7842 158.22)",
    fill: "#66C0DD"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.7842 153.517)",
    fill: "#66C0DD"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 106.358 158.063)",
    fill: "#66C0DD"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 101.734 158.063)",
    fill: "#66C0DD"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.971 158.22)",
    fill: "#66C0DD"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.971 153.517)",
    fill: "#66C0DD"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 133.545 158.063)",
    fill: "#66C0DD"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 128.921 158.063)",
    fill: "#66C0DD"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 132.157 158.22)",
    fill: "#66C0DD"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 132.157 153.517)",
    fill: "#66C0DD"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 160.73 158.063)",
    fill: "#66C0DD"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 156.106 158.063)",
    fill: "#66C0DD"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.343 158.22)",
    fill: "#66C0DD"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.343 153.517)",
    fill: "#66C0DD"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 187.917 158.063)",
    fill: "#66C0DD"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 183.293 158.063)",
    fill: "#66C0DD"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.529 158.22)",
    fill: "#66C0DD"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.529 153.517)",
    fill: "#66C0DD"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 24.7998 183.902)",
    fill: "#66C0DD"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 20.1758 183.902)",
    fill: "#66C0DD"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.4121 184.059)",
    fill: "#66C0DD"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.4121 179.355)",
    fill: "#66C0DD"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 51.9863 183.902)",
    fill: "#66C0DD"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 47.3623 183.902)",
    fill: "#66C0DD"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.5986 184.059)",
    fill: "#66C0DD"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.5986 179.355)",
    fill: "#66C0DD"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 79.1719 183.902)",
    fill: "#66C0DD"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 74.5479 183.902)",
    fill: "#66C0DD"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.7842 184.059)",
    fill: "#66C0DD"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.7842 179.355)",
    fill: "#66C0DD"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 106.358 183.902)",
    fill: "#66C0DD"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 101.734 183.902)",
    fill: "#66C0DD"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.971 184.059)",
    fill: "#66C0DD"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.971 179.355)",
    fill: "#66C0DD"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 133.545 183.902)",
    fill: "#66C0DD"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 128.921 183.902)",
    fill: "#66C0DD"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 132.157 184.059)",
    fill: "#66C0DD"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 132.157 179.355)",
    fill: "#66C0DD"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 160.73 183.902)",
    fill: "#66C0DD"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 156.106 183.902)",
    fill: "#66C0DD"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.343 184.059)",
    fill: "#66C0DD"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.343 179.355)",
    fill: "#66C0DD"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 187.917 183.902)",
    fill: "#66C0DD"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 183.293 183.902)",
    fill: "#66C0DD"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.529 184.059)",
    fill: "#66C0DD"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.529 179.355)",
    fill: "#66C0DD"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 24.7998 209.741)",
    fill: "#66C0DD"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 20.1758 209.741)",
    fill: "#66C0DD"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.4121 209.898)",
    fill: "#66C0DD"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.4121 205.194)",
    fill: "#66C0DD"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 51.9863 209.741)",
    fill: "#66C0DD"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 47.3623 209.741)",
    fill: "#66C0DD"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.5986 209.898)",
    fill: "#66C0DD"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.5986 205.194)",
    fill: "#66C0DD"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 79.1719 209.741)",
    fill: "#66C0DD"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 74.5479 209.741)",
    fill: "#66C0DD"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.7842 209.898)",
    fill: "#66C0DD"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.7842 205.194)",
    fill: "#66C0DD"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 106.358 209.741)",
    fill: "#66C0DD"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 101.734 209.741)",
    fill: "#66C0DD"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.971 209.898)",
    fill: "#66C0DD"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.971 205.194)",
    fill: "#66C0DD"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 133.545 209.741)",
    fill: "#66C0DD"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 128.921 209.741)",
    fill: "#66C0DD"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 132.157 209.898)",
    fill: "#66C0DD"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 132.157 205.194)",
    fill: "#66C0DD"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 160.73 209.741)",
    fill: "#66C0DD"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 156.106 209.741)",
    fill: "#66C0DD"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.343 209.898)",
    fill: "#66C0DD"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.343 205.194)",
    fill: "#66C0DD"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 187.917 209.741)",
    fill: "#66C0DD"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 183.293 209.741)",
    fill: "#66C0DD"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.529 209.898)",
    fill: "#66C0DD"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.529 205.194)",
    fill: "#66C0DD"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 24.7998 235.58)",
    fill: "#66C0DD"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 20.1758 235.58)",
    fill: "#66C0DD"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.4121 235.737)",
    fill: "#66C0DD"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.4121 231.033)",
    fill: "#66C0DD"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 51.9863 235.58)",
    fill: "#66C0DD"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 47.3623 235.58)",
    fill: "#66C0DD"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.5986 235.737)",
    fill: "#66C0DD"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.5986 231.033)",
    fill: "#66C0DD"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 79.1719 235.58)",
    fill: "#66C0DD"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 74.5479 235.58)",
    fill: "#66C0DD"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.7842 235.737)",
    fill: "#66C0DD"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.7842 231.033)",
    fill: "#66C0DD"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 106.358 235.58)",
    fill: "#66C0DD"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 101.734 235.58)",
    fill: "#66C0DD"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.971 235.737)",
    fill: "#66C0DD"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.971 231.033)",
    fill: "#66C0DD"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 133.545 235.58)",
    fill: "#66C0DD"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 128.921 235.58)",
    fill: "#66C0DD"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 132.157 235.737)",
    fill: "#66C0DD"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 132.157 231.033)",
    fill: "#66C0DD"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 160.73 235.58)",
    fill: "#66C0DD"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 156.106 235.58)",
    fill: "#66C0DD"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.343 235.737)",
    fill: "#66C0DD"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.343 231.033)",
    fill: "#66C0DD"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 187.917 235.58)",
    fill: "#66C0DD"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 183.293 235.58)",
    fill: "#66C0DD"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.529 235.737)",
    fill: "#66C0DD"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.529 231.033)",
    fill: "#66C0DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCardOptionDigital);
export default __webpack_public_path__ + "static/media/new-card-option-digital.2f26704f0718ce05cf04c5a2e10ba69c.svg";
export { ForwardRef as ReactComponent };